import { FEATURE_DECISION_KEYS } from '@web-platform/shared-universal-constants-config';
import { getFeatureDecision } from '@web-platform/shared-universal-utils-frontend/src/config';

import { isBananaCombinedResults } from './isBananaCombinedResults';
import {
  isCombinedExploreCitySearchWithMonth,
  isCombinedExploreCitySearchWithAnytime,
} from './isCombinedExploreCitySearch';

import type { DateString } from '@web-platform/shared-universal-types/src/dateString';
import type { SearchLegPlace } from '@web-platform/shared-universal-types/src/redux/state/appInitial/user/search';

const shouldHardRedirect = (
  destination: SearchLegPlace | undefined,
  origin: SearchLegPlace | undefined,
  outboundDate: DateString | undefined,
  isAnytime: boolean | undefined,
  // Force to specify if a hard redirect is required for a specific case.
  presets?: {
    hardRedirectToCombinedResults?: boolean; // combined results
    hardRedirectToCECityMonth?: boolean; // combined explore city search with month
    hardRedirectToCECityAnytime?: boolean; // combined explore city search with anytime
    hardRedirectToCEOtherSearch?: boolean; // combined explore other search cases
  },
): boolean => {
  const shouldAvoidBananaResults = getFeatureDecision(
    FEATURE_DECISION_KEYS.SHOULD_AVOID_BANANA_RESULTS,
  );

  const shouldHardRedirectToDaview = shouldAvoidBananaResults;

  const enableCECitySearchWithAnytime = getFeatureDecision(
    FEATURE_DECISION_KEYS.ENABLE_COMBINED_EXPLORE_ANYTIME_SEARCH,
  );

  const nextPageIsCombinedResults = isBananaCombinedResults(destination, origin, outboundDate);
  const nextPageIsCECitySearchWithMonth = isCombinedExploreCitySearchWithMonth(
    destination,
    origin,
    outboundDate,
  );
  const nextPageIsCECitySearchWithAnytime = isCombinedExploreCitySearchWithAnytime(
    destination,
    origin,
    outboundDate,
    isAnytime,
  );

  // if next page is CR, then redirect or not depends on both presets.hardRedirectToCombinedResults and cookie feature flag
  if (nextPageIsCombinedResults)
    return presets?.hardRedirectToCombinedResults !== undefined
      ? presets?.hardRedirectToCombinedResults
      : shouldHardRedirectToDaview;

  // month search is served by month-view-page in a separate repository; always hard redirect
  if (nextPageIsCECitySearchWithMonth)
    return presets?.hardRedirectToCECityMonth !== undefined
      ? presets?.hardRedirectToCECityMonth
      : true;

  // if next page is CE city search with anytime, then redirect or not depends on feature flag
  if (nextPageIsCECitySearchWithAnytime)
    return presets?.hardRedirectToCECityAnytime !== undefined
      ? presets?.hardRedirectToCECityAnytime
      : !enableCECitySearchWithAnytime;

  return !!presets?.hardRedirectToCEOtherSearch;
};

export { shouldHardRedirect };
